export default "/loader-bounce.4ef97932774d23cdd8774906b9748f4d.svg";